import axios from "axios";

export async function sendFeedback(data) {
  return axios.post("/messages", data);
}

export async function loadYears() {
  return axios.get("/config/years").then(r => r.data);
}

export async function loadCenters() {
  return axios.get("/training-centers").then(r => r.data);
}

export async function search(params) {
  params.per_page = 8;
  return axios.get("/search", { params });
}

export async function loadPupularDocs() {
  return axios.get("/search/popular?per_page=3").then(r => r.data);
}

export async function loadFaq() {
  const params = { per_page: -1 };
  return axios.get("/faq", { params }).then(r => r.data);
}
